/* eslint-disable react-hooks/exhaustive-deps */
import "./style.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Robo from "../../icons/robo.svg?react";
import TwoColumnDragDrop from "../Drag and Drop";
import {
  setAvailableThemes,
  setSelectedThemes,
} from "../../reducers/Audit";
import type { RootState } from "../../store";

interface DragItem {
  id: number | string;
  name: string;
  type?: string;
}

interface Props {
  sourceItems: any[];
  destinationItems: any[];
  auditeesList: any;
  updateAuditeeInfo: any;
  auditData: any;
  sequence?: any;
  auditUpdatedata: any;
  showAICompanion: boolean;
  setShowAICompanion?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Step2AuditTheme: React.FC<Props> = ({
  sourceItems,
  updateAuditeeInfo,
  auditUpdatedata,
  showAICompanion,
  destinationItems,
  setShowAICompanion,
  sequence,
}) => {
  const dispatch = useDispatch();
  const available = useSelector(
    (state: RootState) => state.auditee.step2.availableThemes
  );
  const selected = useSelector(
    (state: RootState) => state.auditee.step2.selectedThemes
  );
  useEffect(() => {
    const hasAuditingId =
      auditUpdatedata?.auditingId !== null &&
      auditUpdatedata?.auditingId !== undefined;

    if (hasAuditingId) {
      const apiSelectedThemes = auditUpdatedata?.auditTheme || [];

      const selectedFromAPI = sourceItems.filter((item: any) =>
        apiSelectedThemes.some((theme: any) => theme.themeName === item.themeName)
      );
      const newSelected = selectedFromAPI.filter(
        (item: any) =>
          !selected.some((sel: any) => sel.themeId === item.themeId)
      );

      const updatedSelected = [...selected, ...newSelected];

      const availableItems = sourceItems.filter(
        (item: any) =>
          !updatedSelected.some((sel: any) => sel.themeId === item.themeId)
      );

      dispatch(setAvailableThemes(availableItems));
      dispatch(setSelectedThemes(updatedSelected));
      updateAuditeeInfo("auditThemes", updatedSelected);
    } else {
      // Create flow - ensure available themes are set correctly
      const filteredAvailable = sourceItems.filter(
        (item: any) =>
          !selected.some((sel: any) => sel.themeId === item.themeId)
      );

      dispatch(setAvailableThemes(filteredAvailable));
      // Don't clear sequence steps here - it's already cleared by resetStep2() in parent
    }
  }, [auditUpdatedata, sourceItems]);

  // ✅ Handle drag updates
  const handleDragUpdate = (newSource: DragItem[], newDest: DragItem[]) => {
    dispatch(setAvailableThemes(newSource));
    dispatch(setSelectedThemes(newDest));
    updateAuditeeInfo("auditThemes", newDest);
  };
  return (
    <div className="form-row-1 marginstep2">
      {!showAICompanion && (
        <div
          role="button"
          tabIndex={0}
          className="outer-circle"
          style={{ margin: "68px 30px 0 0" }}
          onClick={() => setShowAICompanion?.(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setShowAICompanion?.(true);
            }
          }}
        >
          <Robo className="ai-bot-button" />
        </div>
      )}

      <TwoColumnDragDrop
        totalcount={destinationItems}
        totalData={sourceItems}
        sourceItems={available}
        destinationItems={selected}
        onDragUpdate={handleDragUpdate}
        fieldMapping={{
          idKey: "themeId",
          nameKey: "themeName",
          codeKey: "themeCode",
          typeKey: "type",
          countryCode: "countryCode",
          descriptionKey: "themeDescription",
        }}
        layoutMode="accordion"
        leftTitle="Audit Themes"
        rightTitle="Select Themes Here"
      />
    </div>
  );
};

export default Step2AuditTheme;
